import type { LeaveTypeFormValues } from "./LeaveTypeForm";

/** Sample form data for auto-fill on Leave Type create page. */
export const leaveTypeFormSamples: LeaveTypeFormValues[] = [
  {
    name: "ລາກິດ",
    code: "sick",
    description: "ລາພະຍາບານ",
    isPaid: true,
    maxDaysPerYear: 30,
    allowCarryOver: false,
    isActive: true,
    orderIndex: 1,
  },
  {
    name: "ລາພັກ",
    code: "annual",
    description: "ລາພັກຕາມສັນຍາ",
    isPaid: true,
    maxDaysPerYear: 15,
    allowCarryOver: true,
    isActive: true,
    orderIndex: 2,
  },
  {
    name: "ລາບໍ່ໄດ້ຮັບເງິນ",
    code: "unpaid",
    description: "ລາທຸກກິດສ່ວນຕົວ ບໍ່ຮັບເງິນເດືອນ",
    isPaid: false,
    maxDaysPerYear: 10,
    allowCarryOver: false,
    isActive: true,
    orderIndex: 3,
  },
  {
    name: "ລາສົນຸດ",
    code: "compassionate",
    description: "ລາສົນຸດ ຫຼື ລາວັນພິເສດ",
    isPaid: true,
    maxDaysPerYear: 5,
    allowCarryOver: false,
    isActive: true,
    orderIndex: 4,
  },
  {
    name: "ລາກິດລະບົບ",
    code: "maternity",
    description: "ລາຄອບຄົວ ຕາມກົດໝາຍແຮງງານ",
    isPaid: true,
    maxDaysPerYear: 98,
    allowCarryOver: false,
    isActive: true,
    orderIndex: 5,
  },
];
